function parseHrefProp(prop, disabled) {
    const rel = 'noopener noreferrer';
    if (typeof prop === 'string') {
        return {
            href: prop,
            rel,
            disabled,
            onClick: (e) => {
                if (disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
        };
    }
    else if (typeof prop === 'object') {
        return {
            ...prop,
            rel: prop.rel ?? rel,
            disabled: prop.disabled ?? disabled,
            onClick: (e) => {
                if (disabled || prop.disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                prop.onClick?.(e);
            },
        };
    }
    return {
        rel,
        disabled: true,
    };
}

export { parseHrefProp as p };

//# sourceMappingURL=index10.js.map